import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["saveIndicator"]

  saveField(event) {
    const input = event.target
    const row = input.closest("tr")
    const entryId = row.dataset.entryId
    const updateId = row.dataset.updateId
    const field = input.dataset.field
    const value = input.value

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(`/sm/weekly_updates/${updateId}/update_entry`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({
        entry_id: entryId,
        [field]: value
      })
    }).then(response => {
      if (response.ok) {
        this.showSaved()
        // If the field is any_issues, toggle row amber highlight
        if (field === "any_issues") {
          const hasIssue = value.trim() !== "" && value.trim().toLowerCase() !== "no"
          if (hasIssue) {
            row.classList.add("bg-[#FFB74D]/10")
            row.classList.remove("hover:bg-[#F5F3F0]/50")
            input.classList.add("text-[#E57373]", "font-medium")
          } else {
            row.classList.remove("bg-[#FFB74D]/10")
            row.classList.add("hover:bg-[#F5F3F0]/50")
            input.classList.remove("text-[#E57373]", "font-medium")
          }
        }
      }
    })
  }

  createTask(event) {
    const button = event.currentTarget
    const clientId = button.dataset.clientId
    const text = button.dataset.text
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch("/admin/tasks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({
        shared_task: {
          title: text,
          client_id: clientId,
          task_type: "general",
          priority: "medium",
          due_date: this.nextMeetingDate()
        }
      })
    }).then(response => {
      if (response.ok) {
        button.innerHTML = `<svg class="w-4 h-4 text-[#9CAF88]" fill="currentColor" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>`
        button.disabled = true
      }
    })
  }

  showSaved() {
    if (this.hasSaveIndicatorTarget) {
      this.saveIndicatorTarget.classList.remove("hidden")
      clearTimeout(this._saveTimeout)
      this._saveTimeout = setTimeout(() => {
        this.saveIndicatorTarget.classList.add("hidden")
      }, 2000)
    }
  }

  nextMeetingDate() {
    const now = new Date()
    const dayOfWeek = now.getDay()
    // Next Tuesday (assuming weekly meeting is on Tuesday)
    const daysUntilTuesday = (2 - dayOfWeek + 7) % 7 || 7
    const nextTuesday = new Date(now)
    nextTuesday.setDate(now.getDate() + daysUntilTuesday)
    return nextTuesday.toISOString().split("T")[0]
  }
}
